import type { FaireProductEntity } from "../../entity_types/product";

export const p_8wdevd3ab4: FaireProductEntity = {
  token: "p_8wdevd3ab4",
  type: "product",
  name: "Cat Earrings | Cat Lover Mismatched Gold Studs",
  brandToken: "b_8f708017",
  brandName: "Yellow Owl Workshop",
  imageUrl:
    "https://cdn.faire.com/fastly/6a19d64d8a45392783d59ee2a08d08a73587aeeecfcd144a3d08fac9a3adf073.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f4dea34d4924d494f95f8557f0e3c109f3457a1b91e64e2e4eaf54a3fdfadaa0.jpeg",
    "https://cdn.faire.com/fastly/43b36390a5b0825e19b32c1c8c228058f1f31f31b8395dc0773e8c35a0777a31.jpeg",
  ],
  priceDollars: 11.25,
  description:
    "A YOW best seller! 🏆\n\nFor the person whose camera roll is 80% cat photos and 20% screenshots of cat memes to send later. This mismatched pair features two very expressive cats in vivid cloisonné enamel, one fluffy orange icon and one lanky little chaos goblin. Cat lady coded, in the best and most stylish way.\n\nOur most popular category! Mismatched yet perfectly paired, these studs in vivid cloisonné with 22k gold-gilt are tiny works of art. Gift-ready in our signature vials, they’re irresistible bestsellers that keep customers coming back.\n\nProduct details:\n• Case pack: 4\n• 22k gold-gilt, tarnish resistant\n• Nickel-free, lead-free, cadmium-free\n• Hypoallergenic\n• Charms vary in size\n• Gift-ready packaging\n• Glass vial 1 x 2 5/8 in (2.5 x 6.7 cm)\n• Sustainably made\n• Designed in San Francisco",
  tags: [],
  msrpDollars: 28.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:47.549Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
